module.exports = __webpack_public_path__ + "static/media/logo-200x200.d6340dba.png";